import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import "./styles.css";
import { logout } from "../../redux/actions/authActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import logo from "../../assets/logo.png";
import logoutIcon from "../../assets/logout.png";
import GestionProjet from "../../components/GestionProjet";
import ProfilClient from "../ProfilClient";
import { setActiveSection } from "../../redux/actions/dashboardActions";
import { fetchLikesReceived, fetchLikesSent } from "../../redux/actions/likeActions";
import { fetchMatches } from "../../redux/actions/matchActions";
import { faBars, faXmark } from "@fortawesome/free-solid-svg-icons";
import NotificationsDashboard from "../../components/NotificationsDashboard";
import Factures from "../../components/Factures";

// Tu pourras ajouter d’autres composants comme ChiffresAffaires, Clients, etc.

const ClientDashboard = () => {
  const { user: authUser, token } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const { activeSection } = useSelector(state => state.dashboard);
  const notifications = useSelector((state) => state.notification?.list || []); // non-lues si ton API renvoie que non-lues
  const unreadCount = notifications.length;
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (!authUser) navigate("/");
  }, [authUser, navigate]);
  useEffect(() => {
    dispatch(fetchLikesReceived(token));
    dispatch(fetchLikesSent(token));
    dispatch(fetchMatches(token));
  }, [token, dispatch]);
    useEffect(()=>{
        if(activeSection === "")
            dispatch(setActiveSection("projets"));
    },[activeSection,dispatch]);
  const openNotifications = () => {
    dispatch(setActiveSection("notifications"));
    setMenuOpen(false);
  };
  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };


  // Mapping des sections disponibles
  const sections = {
    projets: <GestionProjet />,
    notifications: <NotificationsDashboard />,
    factures: <Factures/>,
    profilClient: <ProfilClient />
    // tu ajoutes d’autres écrans au besoin
  };

  return (
    <main className="client-dashboard">
      <nav className={`client-menu ${menuOpen ? "open" : ""}`}>

        <div className="mobile-header">
          <img src={logo} alt="Logo Intereseaux" className="logo-mobile" />

          <div className="mobile-top-icons">
            <button
              className="icon-btn notif-btn-mobile"
              onClick={openNotifications}
              aria-label="Notifications"
            >
              <FontAwesomeIcon icon={faBell} />
              {unreadCount > 0 && <span className="notif-badge-mobile">{unreadCount}</span>}
            </button>

            <button
              className="icon-btn hamburger-btn"
              onClick={() => setMenuOpen((s) => !s)}
              aria-expanded={menuOpen}
              aria-label="Ouvrir le menu"
            >
              <FontAwesomeIcon icon={menuOpen ? faXmark : faBars} />
            </button>
          </div>
        </div>

        {/* DESKTOP LOGO */}
        <div className="logo-desktop">
          <a href="/espace-prestataire">
            <img src={logo} alt="Logo Intereseaux" className="logo-dashboard-img" />
          </a>
        </div>

        {/* DESKTOP BELL (centered under logo) */}
        <div className="notif-desktop-wrapper">
          <button className="icon-btn notif-btn-desktop" onClick={openNotifications} aria-label="Notifications">
            <FontAwesomeIcon icon={faBell} shake={unreadCount > 0} />
            {unreadCount > 0 && <span className="notif-badge-desktop">{unreadCount}</span>}
          </button>
        </div>


        {/* MENU ITEMS */}
        <ul className="menu-items">
          <li
            className={activeSection === "projets" ? "active" : ""}
            onClick={() => { dispatch(setActiveSection("projets")); setMenuOpen(false); }}>
            MES PROJETS ET PRESTATAIRES
          </li>

          <li
            className={activeSection === "factures" ? "active" : ""}
            onClick={() => { dispatch(setActiveSection("factures")); setMenuOpen(false); }}>
            MES FACTURES
          </li>

          <li
            className={activeSection === "profilClient" ? "active" : ""}
            onClick={() => { dispatch(setActiveSection("profilClient")); setMenuOpen(false); }}>
            MON PROFIL
          </li>

          <li>
            <button className="logout-btn" onClick={handleLogout}>
              <img style={{ width: "30px", height: "30px", objectFit: "contain" }} src={logoutIcon} alt="icone logout" />
            </button>
          </li>
        </ul>

      </nav>


      {/* Zone de contenu */}
      <section className="client-content">
        {sections[activeSection]}
      </section>
    </main>
  );
};

export default ClientDashboard;
